{
  "name": "leap",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:proxy": "ng serve --configuration proxy",
    "prepare": "husky",
    "build": "ng build",
    "build:demo": "ng build --configuration demo",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:ci": "jest --ci",
    "lint": "ng lint",
    "prettier": "prettier \"{**/*,*}.{html,js,ts,md,scss,css,json}\" --check",
    "prettier:write": "prettier \"{**/*,*}.{html,js,ts,md,scss,css,json}\" --write",
    "stylelint": "stylelint \"{**/*,*}.{scss,css}\"",
    "stylelint:fix": "stylelint \"{**/*,*}.{scss,css}\" --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "21.2.1",
    "@angular/common": "^21.2.4",
    "@angular/compiler": "^21.2.4",
    "@angular/core": "^21.2.4",
    "@angular/forms": "^21.2.4",
    "@angular/platform-browser": "^21.2.4",
    "@angular/platform-browser-dynamic": "^21.2.4",
    "@angular/router": "^21.2.4",
    "@azure/msal-angular": "4.0.9",
    "@azure/msal-browser": "4.10.0",
    "@ngx-translate/core": "16.0.4",
    "@ngx-translate/http-loader": "16.0.1",
    "clipboard": "2.0.11",
    "dompurify": "3.3.2",
    "marked": "17.0.2",
    "ngx-markdown": "21.1.0",
    "prismjs": "1.30.0",
    "rxjs": "7.8.2",
    "tippy.js": "6.3.7",
    "tslib": "2.8.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.1.0",
    "@angular-eslint/eslint-plugin": "21.1.0",
    "@angular-eslint/eslint-plugin-template": "21.1.0",
    "@angular-eslint/template-parser": "21.1.0",
    "@angular/build": "^21.2.1",
    "@angular/cli": "21.2.1",
    "@angular/compiler-cli": "^21.2.4",
    "@commitlint/cli": "19.8.0",
    "@commitlint/config-conventional": "19.8.0",
    "@types/node": "22.13.10",
    "eslint": "9.39.2",
    "eslint-plugin-import": "2.31.0",
    "husky": "9.1.7",
    "jsdom": "^25.0.0",
    "lint-staged": "15.4.3",
    "prettier": "3.8.0",
    "stylelint": "16.15.0",
    "stylelint-config-standard": "37.0.0",
    "stylelint-config-standard-scss": "14.0.0",
    "ts-node": "10.9.2",
    "typescript": "5.9.3",
    "typescript-eslint": "8.55.0",
    "vitest": "4.0.8"
  }
}
